exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .container {\r\n    display: flex;\r\n    \r\n    height: 100vh;\r\n   \r\n  \r\n   \r\n}\r\n\r\n.Left,\r\n.Middle {\r\n    overflow: auto;\r\n    height: auto;\r\n    padding: .5rem;\r\n    -webkit-overflow-scrolling: touch;\r\n    -ms-overflow-style: none;\r\n}\r\n\r\n.Left::-webkit-scrollbar,\r\n.Middle::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n\r\n\r\n.Middle {\r\n    flex: 1;\r\n} */\r\n\r\n.Left{\r\n    \r\n    margin-top: 50px;\r\n}\r\n.Middle{\r\n   \r\n    margin-top: 50px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/phoneinfo2/phoneinfo/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main